import { BaseErrorHero } from "./BaseErrorHero";

export const NotFoundHero = () => {
  return <BaseErrorHero hero="404" description="Page Not Found" />;
};
